module.exports = __webpack_public_path__ + "static/media/154.67f6be8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/154.jpg
// module id = 943
// module chunks = 0